// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"d301dab0","79":"c8a68fe0","243":"50287c85","259":"bc6cdf73","426":"6deded51","915":"c927e6e3"}[chunkId] + ".chunk.css";
};